import { useQuery } from '@tanstack/react-query';
import { HcpSwitchoverApi } from '../../../apis/HcpSwitchoverApi/HcpSwitchoverApi.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';

export const useGetHcpSwitchoverReadiness = () =>
    useQuery({
        queryKey: [QueryKeys.hcpSwitchoverReadiness],
        queryFn: () => HcpSwitchoverApi.getReadiness(),
    });
